// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { debounce } from 'lodash';
import { connect } from 'react-redux';

// Utils
import { hasChanged, noLonger } from '../../../../utils/react/propsComparisons';

// Selector
import { socketConnectedSelector } from '../../../../utils/socket/socketConnectionSelector';
import { appDisableSocketStatusWarningsSelector } from '../../../../offline/appServerConnection/appServerReconnectionSelector';
// Components
import Spinner from '../../../../components/loaders/Spinner';

const lastActionHasChanged = hasChanged('lastAction');
const noLongerConnectionInterruption = noLonger('isConnectionInterrupted');

const mapStateToProps = (state) => ({
    lastAction: state.get('lastSaved'),
    isConnectionInterrupted: !socketConnectedSelector(state),
    disableSocketStatusWarnings: appDisableSocketStatusWarningsSelector(state),
});

@connect(mapStateToProps)
class SavingFeedbackUtil extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showLoading: false,
            hidden: true,
        };

        this.stopSaving = debounce(() => {
            this.setState({ showLoading: false });
            this.hide();
        }, 2000);

        this.hide = debounce(() => {
            this.setState({ hidden: true });
        }, 4000);
    }

    componentWillReceiveProps(nextProps) {
        const showSavingFeedback =
            lastActionHasChanged(this.props, nextProps) ||
            (!nextProps.disableSocketStatusWarnings && noLongerConnectionInterruption(this.props, nextProps));

        if (showSavingFeedback) {
            this.setState({ showLoading: true, hidden: false });
            this.stopSaving();
            this.hide.cancel();
        }
    }

    componentWillUnmount() {
        this.stopSaving.cancel();
        this.hide.cancel();
    }

    render() {
        const { showLoading, hidden } = this.state;
        const { isConnectionInterrupted, disableSocketStatusWarnings } = this.props;

        if (isConnectionInterrupted && !disableSocketStatusWarnings) {
            return (
                <div className="SavingFeedbackUtil CurrentBoardHeaderStatus">
                    <Spinner show />
                    <span className="connection-interrupted">Trying to reconnect...</span>
                </div>
            );
        }

        return (
            <div className={classNames('SavingFeedbackUtil CurrentBoardHeaderStatus', { hidden })}>
                {showLoading ? <span className="saving">Saving...</span> : <span className="save">Saved</span>}
            </div>
        );
    }
}

SavingFeedbackUtil.propTypes = {
    lastAction: PropTypes.bool,
    disableSocketStatusWarnings: PropTypes.bool,
    isConnectionInterrupted: PropTypes.bool,
};

export default SavingFeedbackUtil;
